module.exports = __webpack_public_path__ + "static/media/anc5ru.4c492565.pdf";